module.exports = __webpack_public_path__ + "img/Feature.f955a318.jpg";